import {Component} from '@angular/core';

import {NotificationAlertsService} from './notification-alerts.service';
import {NotificationAlertsMessage} from './notification-alerts-message.model';

@Component({
    selector: 'notification-alerts',
    imports: [],
    templateUrl: './notification-alerts.component.html',
    styleUrl: './notification-alerts.component.scss'
})
export class NotificationAlertsComponent {
    constructor(private notificationAlertsService: NotificationAlertsService) {}

    closeMessage(message: NotificationAlertsMessage) {
        this.notificationAlertsService.removeMessage(message);
    }

    getMessages() {
        return this.notificationAlertsService.messages;
    }
}
